import { Route, Switch } from "react-router-dom";
import AcordoPages from "./Acordo";
import ArrecadaoPages from "./Arrecadacao";
import CrmCobrancaPages from "./CrmCobranca";
import ReceberPages from "./Receber";
import ContaRecorrenteReceitaPage from "./ContaRecorrente/index";
import AuthRoute from "ui/components/AuthRoute";
import { TipoTenantEnum } from "core/resources/enums/tenant";

function ReceitaPages() {
  return (
    <Switch>
      <Route path="/financeiro/receita/acordo" component={AcordoPages} />
      <Route path="/financeiro/receita/cobranca" component={CrmCobrancaPages} />
      <Route path="/financeiro/receita/receber" component={ReceberPages} />
      <AuthRoute
        path="/financeiro/receita/arrecadacoes"
        component={ArrecadaoPages}
        tenantTypes={[TipoTenantEnum.Condominio, TipoTenantEnum.Admin]}
      />
      <Route
        path="/financeiro/receita/conta-recorrente"
        component={ContaRecorrenteReceitaPage}
      />
    </Switch>
  );
}

export default ReceitaPages;
